import {user as userDataLayer} from "./user";

export {
    userDataLayer,
};
